import React, { useState } from 'react';
import {
  Text,
  Stack,
  Flex,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Input,
  Button,
  Textarea,
} from '@chakra-ui/react';
import BrandButton from '../brandButton/BrandButton';
import { AiFillCustomerService, AiFillWarning } from 'react-icons/ai';
import { mutateFunction, useMutation } from '../../libs/apis';
import { CustomToast } from '../toast/CustomToast';
import CreatePost from '../feed/CreatePost';
import EditPost from '../feed/EditPost';

export default function EditPostModal({
  isOpen,
  onClose,
  post = null,
  onSuccess = (post) => {},
}) {
  const { mutate, isLoading } = useMutation(mutateFunction);
  const { addToast } = CustomToast();
  const [postMessage, setPostMessage] = useState('');

  if (!isOpen) return null;

  return (
    <div>
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalBody p={4}>
            <Flex flexDirection="column">
              <Stack spacing={6}>
                <Flex className="items-center gap-2" justify={'center'}>
                  <Text
                    fontSize={20}
                    fontWeight={700}
                    color="brand.primary"
                    align="center"
                  >
                    Edit Post
                  </Text>
                  {/* <AiFillCustomerService style={{ color: "rgba(0,0,0,0.7)", fontSize: "28px" }} /> */}
                </Flex>

                <Text fontSize={14} color="#000000">
                  Share your thoughts.
                </Text>
              </Stack>
              <EditPost onClose={onClose} post={post} onEditPost={onSuccess} />
            </Flex>
          </ModalBody>
        </ModalContent>
      </Modal>
    </div>
  );
}
